// export const url = 'http://localhost:8080/'
export const url = 'https://immo.pategou.com:8098/'
export const googleApiKey = "AIzaSyBewJ2x5COtaqlSdrt8DdKObNP_rRWCEEE";